module.exports = __webpack_public_path__ + "static/media/no-smoking-light-gray.778344d2.svg";